export const language: any ={
    cancel: "အလျော့ချခြင်း",
    ok: "အိုကေ",
}
